  document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.querySelector('.header_search-modal');
    const predictiveSearch = document.querySelector('predictive-search');

    toggleBtn.addEventListener('click', function () {
      if (!predictiveSearch) return;

      const isVisible = predictiveSearch.style.display === 'block';

      predictiveSearch.style.display = isVisible ? 'none' : 'block';
    });
  });